import React from "react";
import { Alert, Form, Modal, Row, Col } from "react-bootstrap";
import _renderVendor from "./_renderVendor";
import apiEndPoints from "../../../componets/json/apiEndPoints.json"
class _selectVendor extends React.Component {
    state = { vendors: [], filterValue: "" }
    getVendors = async () => {
        this.setState({ loading: { ...this.state.loading, status: true } });
        const _res = await this.props._api({
            ...this.props,
            method: "get",
            endpoint: apiEndPoints.britex.LookUpValue.vendors_v2,
            param: "",
        });
        this.setState({ loading: { ...this.state.loading, status: false } });
        if (_res.status == 200) {
            this.setState({ vendors: JSON.parse(this.props._decrypt(_res.data)) });
        }
    }
    componentDidMount() {
        this.getVendors();
    }

    filterFunc = (data) => {
        let filterData = data;
        if (filterData) {
            if (this.state.filterValue.length > 0) {
                const fulltext = JSON.stringify(filterData);
                return fulltext.toUpperCase().indexOf(this.state.filterValue.toUpperCase()) > -1
            } else {
                return filterData;
            }

        }
    }

    render() {
        return (<>
            <Modal
                show={this.props.open}
                onHide={() => this.props.onHide()}
                centered
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <span className="h5">Vybrat výrobce</span>
                    </Modal.Title>
                </Modal.Header>
                <Alert variant="warning">
                    <Row className="d-flex justify-content-end">
                        <Col xs={3} className="d-flex justify-content-end">
                            <Form.Control type="text" placeholder="...filtrovat" value={this.state.filterValue} onChange={(e) => this.setState({filterValue: e.target.value})} />
                        </Col>
                    </Row>
                </Alert>
                <Modal.Body>

                    {this.state.loading?.status && (
                        <this.props._placeholder line={[{size: 6}]} />
                    )}

                    {this.state.vendors.length > 0 && (
                        <>
                            {this.state.vendors.filter(f => f.isWebReqAllow).filter(this.filterFunc).map((e, idx) => (
                                <div onClick={() => this.props.select(e, idx)} className="cursor-pointer">
                                    <_renderVendor e={e} />
                                </div>
                            ))}</>
                    )}
                </Modal.Body>
            </Modal>
        </>)
    }
}

export default _selectVendor;